import {
  PaymentDetailsResponse,
  POSTPaymentDetails,
} from '@/apis/providers/requests'
import {
  DOCUMENT_TYPES,
  PAYMENT_TYPES,
  PaymentPayload,
} from '@/apis/providers/types/provider.types'
import { useAppAlert } from '@/app/AppAlertProvider'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import CreateProviderPaymentForm, {
  ProviderPaymentDetails,
} from './create_provider_request_form'
import ProviderPaySuccess from './ProviderPaySuccess'
import { RequestError } from '@/common/types_and_interfaces.ts'

export function CreateProviderRequestPage() {
  const programId = useSelector(selectProgramID)
  const { fireAlert } = useAppAlert()
  const mutation: UseMutationResult<
    PaymentDetailsResponse,
    RequestError,
    PaymentPayload
  > = useMutation({
    mutationFn: async (payload: PaymentPayload) => {
      return await POSTPaymentDetails(payload)
    },
    onError: (error) => {
      fireAlert({
        variant: 'error',
        message: error.message,
      })
    },
  })

  function handleFormSubmit(paymentData: ProviderPaymentDetails) {
    const paymentPayload: PaymentPayload = {
      program_id: programId,
      provider_id: paymentData.provider.id,
      global_expense_categories: paymentData.expenseCategories.map(
        (category) => ({
          amount: category.amount,
          id: category.id,
        })
      ),
      type: PAYMENT_TYPES.PROVIDER,
      invoice_quote: paymentData.invoiceNumber,
      comments: paymentData.comments,
      files: paymentData.documents.map((doc) => ({
        file_name: doc.file_name,
        document_type: DOCUMENT_TYPES.INVOICE,
        student_id: doc.student_id ?? 0,
        invoice_number: doc.invoice_number ?? '',
        invoice_date: doc.invoice_date ?? '',
        amount: doc.amount ?? 0,
        ...(doc.notes ? { notes: doc.notes } : {}),
      })),
      purses: paymentData.purses.map((purse) => ({
        purse_id: purse.purse_id,
        amount: purse.amount,
      })),
      base_amount: paymentData.amount,
    }

    mutation.mutate(paymentPayload)
  }

  if (mutation.status === 'success') {
    return (
      <div className="max-w-lg mx-auto">
        <ProviderPaySuccess status={mutation.data.status} />
      </div>
    )
  }

  return (
    <div>
      <CreateProviderPaymentForm
        onExitFormBackClick={() => {}}
        mutationStatus={mutation.status}
        onSubmit={handleFormSubmit}
      />
    </div>
  )
}
